var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "@lysaab/ui-2";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";
import { LocalStorage } from "../../data/localStorage";
import { useQuery } from "../../hooks/useQuery";
import "./NetsDonePage.scss";
function postError(_a) {
    var _b;
    var code = _a.code, message = _a.message, resp = _a.resp, query = _a.query;
    var messageData = {
        status: "NETS_ERROR",
        error: query.error,
        errorDescription: query.error_description,
        code: code !== null && code !== void 0 ? code : query.code,
        message: message,
        resp: resp,
    };
    (_b = window.opener) === null || _b === void 0 ? void 0 : _b.postMessage(messageData, "*");
}
export var NetsDonePage = function (_a) {
    var netsDone = _a.netsDone;
    var country = useParams().country;
    var query = useQuery();
    var queryAsString = JSON.stringify(query);
    useEffect(function () {
        var _a;
        var query = JSON.parse(queryAsString);
        if (query.error || query.error_description) {
            postError({ message: "Error before sending netsDone", query: query });
        }
        else {
            (_a = window.opener) === null || _a === void 0 ? void 0 : _a.postMessage({ status: "NETS_RETURNED", code: query.code, state: query.state }, "*");
        }
    }, [queryAsString]);
    useEffect(function () {
        var query = JSON.parse(queryAsString);
        var testUrl = window.location.hostname === "localhost"
            ? window.location.origin + window.location.pathname
            : undefined;
        if (window.location.hostname === "localhost" &&
            window.location.port !== "3000") {
            console.error("You need to run on localhost:3000 for Nets to work");
        }
        netsDone(country, __assign(__assign({}, query), (testUrl && { testUrl: testUrl })))
            .then(function (_a) {
            var _b, _c, _d, _e;
            var resp = _a[0], url = _a[1];
            if (query.error) {
                return;
            }
            if (resp.status === "fulfilled") {
                if (resp.value.status === "TIMED_OUT") {
                    (_b = window.opener) === null || _b === void 0 ? void 0 : _b.postMessage({ status: "NETS_TIMED_OUT", resp: [resp, url] }, "*");
                    return;
                }
                if (resp.value.person) {
                    var maxAge = 60 * 60 * 24 * 395;
                    document.cookie = "lysa_nets_authenticator=".concat(resp.value.person.authenticator, "; path=/; max-age=").concat(maxAge);
                    document.cookie = "lysa_nets_sub_authenticator=".concat(resp.value.person.subAuthenticator, "; path=/; max-age=").concat(maxAge);
                    document.cookie = "lysa_nets_pid=".concat(resp.value.person.pid, "; path=/; max-age=").concat(maxAge);
                }
                if (resp.value.status === "NEED_CPR") {
                    (_c = window.opener) === null || _c === void 0 ? void 0 : _c.postMessage({ status: "NETS_NEED_CPR", resp: [resp, url] }, "*");
                    return;
                }
                if (resp.value.status === "NOT_CUSTOMER") {
                    (_d = window.opener) === null || _d === void 0 ? void 0 : _d.postMessage({ status: "NETS_NOT_CUSTOMER", resp: [resp, url] }, "*");
                    return;
                }
                (_e = window.opener) === null || _e === void 0 ? void 0 : _e.postMessage({ status: "NETS_DONE", resp: [resp, url] }, "*");
            }
            else {
                postError({
                    message: "Promises from netsDone not fulfilled",
                    resp: [resp, url],
                    query: query,
                });
            }
        })
            .catch(function (e) {
            var _a, _b, _c, _d;
            postError({
                code: (_b = (_a = e.data) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : e.status,
                message: (_d = (_c = e.data) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : e.message,
                query: query,
            });
        })
            .finally(function () {
            if (!LocalStorage.getItem(LocalStorage.Key.KEEP_POPUP_OPEN)) {
                window.close();
            }
        });
    }, [netsDone, queryAsString, country]);
    return (_jsxs("div", __assign({ className: "nets-done-page" }, { children: [_jsx("header", { children: _jsxs("h1", { children: [_jsx(FormattedMessage, { id: "netsDone.logo-text" }), _jsx("span", __assign({ className: "spacer" }, { children: "|" })), _jsx(Icon.Logo, { size: 18 })] }) }), _jsxs("div", __assign({ className: "content" }, { children: [_jsx("h1", { children: _jsx(FormattedMessage, { id: "netsDone.header" }) }), _jsx("p", { children: _jsx(FormattedMessage, { id: "netsDone.close" }) })] }))] })));
};
